import {defineAsyncComponent} from 'vue'

export default (app: any) => {
	app.component('alert-detail-modal', defineAsyncComponent(() => import(/* webpackChunkName: "AlertDetailModal" */ 'components/support/AlertDetailModal.vue')))
	app.component('alert-dashboard-hotel', defineAsyncComponent(() => import(/* webpackChunkName: "AlertDashboardHotel" */ 'components/support/AlertDashboardHotel.vue')))
	app.component('alert-classifier-admin', defineAsyncComponent(() => import(/* webpackChunkName: "AlertClassifierAdmin" */ 'components/support/AlertClassifierAdmin.vue')))
}
